import { render, staticRenderFns } from "./SocketCompatibilityReport.vue?vue&type=template&id=611fecdf&"
import script from "./SocketCompatibilityReport.vue?vue&type=script&lang=ts&"
export * from "./SocketCompatibilityReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardText,VTooltip})
